import { SearchSortOptions } from '@modules-rocco/search/types/enum/search-sort-options';
import { SearchIndexes } from '@modules-rocco/search/types/enum/search-indexes';

interface AvailableSortOption {
    title: string;
    value: SearchSortOptions;
    adminOnly: boolean;
    searchPageOnly: boolean;
    nonSearchPage: boolean;
    supportSearchIndexes: SearchIndexes[];
}

export const availableSortOptions: AvailableSortOption[] = [
    {
        title: 'Best match',
        value: SearchSortOptions.Featured,
        adminOnly: false,
        searchPageOnly: true,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'Featured',
        value: SearchSortOptions.Featured,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: true,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'Popular (All time)',
        value: SearchSortOptions.Popular,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'New',
        value: SearchSortOptions.New,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'Trending',
        value: SearchSortOptions.Trending,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'Price (Low first)',
        value: SearchSortOptions.LowPrice,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: true,
        supportSearchIndexes: [SearchIndexes.Products],
    },
    {
        title: 'Price (High first)',
        value: SearchSortOptions.HighPrice,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: true,
        supportSearchIndexes: [SearchIndexes.Products],
    },
    {
        title: 'Recently updated',
        value: SearchSortOptions.Updated,
        adminOnly: false,
        searchPageOnly: false,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
    {
        title: 'Newly created',
        value: SearchSortOptions.NewlyCreated,
        adminOnly: true,
        searchPageOnly: false,
        nonSearchPage: false,
        supportSearchIndexes: [
            SearchIndexes.Articles,
            SearchIndexes.Products,
            SearchIndexes.Professionals,
            SearchIndexes.Projects,
        ],
    },
];
